import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { NoticeboardButton } from "../components/shared";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: "center",
        gap: { xs: 3, md: 6 },
        minHeight: "70vh",
        px: { xs: 3, md: 6 },
      }}
    >
      <Box
        sx={{
          textAlign: { xs: "center", md: "left" },
          maxWidth: 480,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "4rem", md: "6rem" },
            fontWeight: 700,
            color: "primary.main",
            lineHeight: 1,
            mb: 1,
          }}
        >
          404
        </Typography>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            color: "text.primary",
            mb: 1.5,
          }}
        >
          Page not found
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            mb: 4,
            lineHeight: 1.6,
          }}
        >
          The page you're looking for doesn't exist or has been moved. Check the
          URL or head back to the dashboard.
        </Typography>
        <Box sx={{ display: "flex", gap: 2, justifyContent: { xs: "center", md: "flex-start" } }}>
          <NoticeboardButton
            variant="primary"
            size="medium"
            onClick={() => navigate("/")}
          >
            Go to Dashboard
          </NoticeboardButton>
          <NoticeboardButton
            variant="secondary"
            size="medium"
            onClick={() => navigate(-1 as any)}
          >
            Go Back
          </NoticeboardButton>
        </Box>
      </Box>
      <Box
        component="img"
        src="/404.webp"
        alt="404 illustration"
        sx={{
          width: { xs: 260, sm: 320, md: 400 },
          height: "auto",
          objectFit: "contain",
          order: { xs: -1, md: 0 },
        }}
      />
    </Box>
  );
};

export default NotFound;
